import React, { useEffect, useState } from "react";
import "../../styles/sortableData.scss";
import { useSortableData } from "../../utils/UseSorteableDataHook";
import { ContractDTO } from "../../dto/ContractDTO";
import {
  axiosInstanceContratos,
  axiosInstanceMain,
} from "../../utils/axiosGlobalUtils";
import AdminLocalContractsRenovations from "./AdminLocalContractsRenovations";
import { hash } from "../../utils/hashFunction";
import ModalTableHistorial from "./ModalTableHistorial";
import ModalTableCtaCte from "./ModalTableCtaCte";
import { Button } from "../../components/Common/button/button.component";
import { RolType } from "../Navbar/Sidebar/SidebarItems";
import {
  Box,
  FormControlLabel,
  Switch,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { styled } from "@mui/material";

const ContentTable = styled("div")(({ isMobile }: { isMobile: boolean }) => ({
  width: isMobile ? "100%" : "97%",
  overflowX: isMobile ? "auto" : "visible",
}));

const ContentButtonCtaCte = styled("div")({
  width: "98%",
  display: "flex",
  justifyContent: "end",
  marginTop: "-18px",
});

const ButtonTable = styled(Button)(({ theme }) => ({
  fontSize: "0.75rem",
  margin: "1px",
  width: "85%",
  [theme.breakpoints.down(425)]: {
    width: "100%",
  },
}));

const AdminLocalContracts: React.FC<any> = (props: any) => {
  const [showRenovations, setShowRenovations] = useState<boolean>(false);
  const [showHistory, setShowHistory] = useState<boolean>(false);
  const [contractIdChecked, setContractIdChecked] = useState<number>();
  const [showCtaCte, setShowCtaCte] = useState<boolean>(false);
  const [contracts, setContracts] = useState<ContractDTO[]>([]);
  const [renewContract, setRenewContract] = useState<ContractDTO>();
  const [forzarRenovables, setForzarRenovables] = useState<boolean>(false);
  const { items, requestSort, sortConfig } = useSortableData(contracts);
  const [idLocal, setIdLocal] = useState<string>();
  const [loading, setLoading] = useState<boolean>(false);
  const isOperador = props?.props?.logged?.userLogged?.roles.includes(
    RolType.MOD
  );
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const getClassNamesFor = (name: string) => {
    if (!sortConfig) {
      return;
    }
    return sortConfig["key"] === name ? sortConfig["direction"] : undefined;
  };

  const closeModalRenovation = () => {
    setShowRenovations(false);
  };

  const closeModalHistory = () => {
    setShowHistory(false);
  };

  const closeModalCtaCte = () => {
    setShowCtaCte(false);
  };

  useEffect(() => {
    if (props.premise) {
      setIdLocal(props.premise?.idLocal);
      getLocal(props.premise?.idLocal, forzarRenovables);
    }
  }, [props.premise, forzarRenovables]);

  const getLocal = async (idLocal: any, forzarRenovables: boolean) => {
    const clave = await hash(idLocal.toString() + "lugares2017");
    const url = forzarRenovables
      ? `/contratos/local/${idLocal}?clave=${clave}&forzar-renovable=true`
      : `/contratos/local/${idLocal}?clave=${clave}`;
    axiosInstanceContratos
      .get(url)
      .then((result) => {
        result.data.sort(
          (a: any, b: any) => a.fechaFinFormateada - b.fechaFinFormateada
        );
        setContracts(result.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <>
      {!isOperador && (
        <AdminLocalContractsRenovations
          contract={renewContract}
          show={showRenovations}
          handleClose={closeModalRenovation}
          getLocal={getLocal}
          idLocal={props.premise?.idLocal}
          forzarRenovables={forzarRenovables}
          updateLocal={props.updateLocal}
        />
      )}
      <ModalTableHistorial
        show={showHistory}
        handleClose={closeModalHistory}
        headers={["Fecha", "Estado", "Fecha inicio", "Fecha fin", "Obs"]}
        attributesToShow={[
          "fecha",
          "estadoNombre",
          "fechaInicio",
          "fechaFin",
          "observaciones",
        ]}
        getUrl={`/contratos/${contractIdChecked}/historial`}
        title={"Historial"}
      />
      <ModalTableCtaCte
        show={showCtaCte}
        handleClose={closeModalCtaCte}
        headers={[
          "ID Contrato",
          "Fecha",
          "Producto",
          "Movimiento",
          "Medio de pago",
          "Comisión",
          "Obs",
        ]}
        idLocal={idLocal}
        title={"Cuenta Corriente"}
      ></ModalTableCtaCte>

      <Box
        sx={{
          display: "flex",
          gap: "12px",
          alignItems: "flex-end",
          justifyContent: "flex-end",
          width: "98%",
        }}
      >
        <Box sx={{ alignSelf: "flex-start" }}>
          <button
            className="btn btn-secondary premise-info-child"
            style={{ fontSize: "1rem" }}
            onClick={() => {
              setShowCtaCte(true);
            }}
          >
            Cta Cte
          </button>
        </Box>
        <Box>
          <FormControlLabel
            label="Forzar renovables"
            control={
              <Switch
                onChange={(e) => setForzarRenovables(e.target.checked)}
                checked={forzarRenovables}
              />
            }
          />
        </Box>
      </Box>

      <ContentTable isMobile={isMobile}>
        <table className="table table-striped table-bordered premise-table">
          <thead className="table-active">
            <tr
              style={{
                ...(isMobile && { fontSize: "14px" }),
              }}
            >
              <th>
                <button
                  type="button"
                  onClick={() => requestSort("idContrato")}
                  className={getClassNamesFor("idContrato")}
                >
                  ID
                </button>
              </th>
              <th>
                <button
                  type="button"
                  onClick={() => requestSort("productoNombre")}
                  className={getClassNamesFor("productoNombre")}
                >
                  Producto
                </button>
              </th>
              <th>
                <button
                  type="button"
                  onClick={() => requestSort("fechaFinFormateada")}
                  className={getClassNamesFor("fechaFinFormateada")}
                >
                  Vencimiento
                </button>
              </th>
              <th>
                <button
                  type="button"
                  onClick={() => requestSort("estadoNombre")}
                  className={getClassNamesFor("estadoNombre")}
                >
                  Estado
                </button>
              </th>
              {!isOperador && (
                <th
                  style={{
                    ...(isMobile && { fontSize: "14px" }),
                  }}
                >
                  <button
                    type="button"
                    onClick={() => requestSort("precioLista")}
                    className={getClassNamesFor("precioLista")}
                  >
                    Precio
                  </button>
                </th>
              )}
              {!isOperador && (
                <th
                  style={{
                    ...(isMobile && { fontSize: "14px" }),
                  }}
                >
                  <button
                    type="button"
                    onClick={() => requestSort("saldo")}
                    className={getClassNamesFor("saldo")}
                  >
                    Saldo Pendiente
                  </button>
                </th>
              )}
              <th>
                <button
                  type="button"
                  onClick={() => requestSort("observaciones")}
                  className={getClassNamesFor("observaciones")}
                >
                  Observaciones
                </button>
              </th>
              {!isOperador && (
                <>
                  <th style={{ width: "13vmin" }}></th>
                  {items.some((i: ContractDTO) => {
                    return (
                      i.accionesAdminList && i.accionesAdminList.length > 0
                    );
                  }) && <th style={{ width: "13vmin" }}></th>}
                </>
              )}
            </tr>
          </thead>
          <tbody>
            {items?.map((item: ContractDTO, index) => {
              return (
                <tr
                  key={index}
                  style={{
                    ...(isMobile && { fontSize: "14px" }),
                  }}
                >
                  <th>{item.idContrato}</th>
                  <th style={{ backgroundColor: `#${item.colorProducto}` }}>
                    {item.cantidad > 1
                      ? item.productoNombre + "x" + item.cantidad
                      : item.productoNombre}
                  </th>
                  <th>{item.fechaFinFormateada}</th>
                  <th style={{ backgroundColor: `#${item.colorEstado}` }}>
                    {item.estadoNombre}
                  </th>
                  {!isOperador && <th>{item.precioLista}</th>}
                  {!isOperador && <th>{item.saldo}</th>}
                  <th>{item.observaciones}</th>

                  <th style={{ padding: "4px" }}>
                    <ButtonTable
                      // disabled={!item.renovable}
                      size="small"
                      className="btn btn-secondary premise-info-child"
                      onClick={() => {
                        setContractIdChecked(item.idContrato);
                        setShowHistory(true);
                      }}
                    >
                      Historial
                    </ButtonTable>
                  </th>
                  {item.accionesAdminList !== null &&
                    item.accionesAdminList !== undefined &&
                    item.accionesAdminList &&
                    item.accionesAdminList.length > 0 &&
                    !isOperador && (
                      <th style={{ padding: "4px" }}>
                        <ButtonTable
                          // disabled={
                          //   item.accionesAdminList === null ||
                          //   item.accionesAdminList === undefined ||
                          //   (item.accionesAdminList &&
                          //     item.accionesAdminList.length === 0)
                          // }
                          size="small"
                          className="btn btn-primary premise-info-child"
                          onClick={() => {
                            setShowRenovations(true);
                            setRenewContract(item);
                          }}
                        >
                          Acciones
                        </ButtonTable>
                      </th>
                    )}
                </tr>
              );
            })}
          </tbody>
        </table>
      </ContentTable>
    </>
  );
};

export default AdminLocalContracts;
